import { render, staticRenderFns } from "./FreeVehicleEnrollment.vue?vue&type=template&id=4850e136&"
import script from "./FreeVehicleEnrollment.vue?vue&type=script&lang=js&"
export * from "./FreeVehicleEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports